import { H2Text } from '@prisjakt/ui/text/variants';
import React from 'react';

// Deviation from design system to avoid pushing down content due to long titles, we need a better solution to this problem
export const SpecialPageTitle: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = props => {
  return <H2Text container="h1">{props.children}</H2Text>;
};
